import BadgesCell from "@/components/NewTable/BadgesCell";

export const columns = () => {
  return [
    {
      accessorKey: "hierarchy",
      header: "Hierarchy",
      size: 60,
      cell: ({ row }) => (
        <div className={"flex justify-center"}>
          {row.original.level}.{row.original.order}
        </div>
      ),
    },
    {
      accessorKey: "sport.code",
      header: "Sport ID",
    },
    {
      id: "code",
      accessorFn: (row) => `${row.code} - ${row.name}`,
      header: "Team Group",
    },
    {
      id: "teams",
      accessorFn: (row) => row.teams,
      header: "Team",
      enableSorting: false,
      cell: ({ row }) => <BadgesCell items={row.original.teams} />,
    },
  ];
};
